module.exports = __webpack_public_path__ + "img/icon-ig.06c7d0be.svg";